<template>
    <div class="side-bar">
        <!--        侧边栏内容-->
        <v-toolbar dark flat height="50">
            <v-tabs v-model="$store.state.isGallery" fixed-tabs @change="changeSidebar" active-class="select-first-level" slider-color="#212D31">
                <v-tab><img v-show="$store.state.isGallery===0" src="/dataLab/icon.png" style="margin: 13px 8px;width:13px;height: 13px;" >影像库</v-tab>
                <v-tab><img v-show="$store.state.isGallery===1" src="/dataLab/icon.png" style="margin: 13px 8px;width:13px;height: 13px;" >订单中心</v-tab>
            </v-tabs>
        </v-toolbar>
        <v-tabs-items dark v-model="$store.state.isGallery" style="width:100%;height: 100%;">
            <v-tab-item style="height: calc(100% - 50px)">
                <v-toolbar dark flat height="40">
                    <!--  影视库一级子功能UI  -->
                    <v-tabs fixed-tabs v-model="$store.state.myLabFucChecked" background-color="#2F4249" @change="changeGalleryTab">
                        <v-tabs-slider style="width: 85%;margin: 0px 7.5%;"></v-tabs-slider>
                        <v-tab v-for="gallery in galleryTabs" :key="gallery.tab">
                            <img
                                    :src="gallery.srcWhite" style="margin: 13px 8px;"
                                    :style="{
                                        filter: gallery===galleryTabs[$store.state.myLabFucChecked]?'none':'brightness(50%)',
                                        width: gallery.width+'px', height: gallery.height+'px'
                                    }"
                            >
                            {{ gallery.tab }}
                        </v-tab>
                    </v-tabs>
                </v-toolbar>
                <!-- 在这里写影像库的页面 -->
                <v-tabs-items dark v-model="$store.state.myLabFucChecked" style="height: 100%;">
                    <!-- 浏览 -->
                    <v-tab-item>
                        <v-toolbar flat>
                            <!-- 记录：数据类型，成像卫星，时间 -->
                            <v-tabs fixed-tabs hide-slider v-model="galleryBrowser">
                                <v-tab
                                        v-for="opt in browserTabs" :key="opt.tab" style="padding: 0px"
                                       @click="showTabs(browserTabs[galleryBrowser].tab, opt.tab, browserTabs)"
                                >
                                    <div>
                                        <img
                                                :src="opt.srcWhite" style="width:16px;height:16px;margin: 13px 8px;"
                                                :style="{filter: !showLevel4||(showLevel4&&opt.show)?'none':'brightness(50%)'}"
                                        >
                                    </div>
                                    <div>
                                        <span :style="{color: !showLevel4||(showLevel4&&opt.show)?'white':'gray'}">{{ opt.tab }}</span><br>
                                        <span :style="{color: opt.show?'#329999':'gray'}">{{ opt.text }}</span>
                                    </div>
                                </v-tab>
                            </v-tabs>
                        </v-toolbar>
                        <v-tabs-items dark v-model="galleryBrowser" v-if="showLevel4">
                            <!--  选择数据类型  -->
                            <v-tab-item class="gallery-item">
                                <v-checkbox
                                        v-model="tempDataTypeSelect" hide-details style="margin: 0px; padding: 0px;width: 25%;"
                                        v-for="(item, index) in dataTypeList" :key="index" :label="item.label" :value="item.value"
                                ></v-checkbox>
                                <div style="display: flex;justify-content: center;width: 100%;">
                                    <v-btn
                                            width="65" height="25" @click="confirmDataType"
                                            style="margin: 8px 43px 10px 0px;background-color: #08A9AE;color: #FFFFFF;font-size: 12px;"
                                    >确定</v-btn>
                                    <v-btn
                                            outlined width="65" height="25" @click="resetDataType"
                                            style="margin: 8px 0px 10px;color: #08A9AE;font-size: 12px;"
                                    >重置</v-btn>
                                </div>
                            </v-tab-item>
                            <!--  选择成像卫星  -->
                            <v-tab-item class="gallery-item" style="margin: 7px 5px;">
                                <v-expansion-panels v-model="expansionIndex" flat dark multiple accordion>
                                    <v-expansion-panel v-for="( line, index ) in satelliteGroup" :key="index">
                                        <v-expansion-panel-header style="min-height:40px;background-color: #212D31;margin-bottom: 1px;">
                                            <div style="width: 100%;display: flex;">
                                                <v-checkbox
                                                        hide-details color="#F3EFEF"
                                                        @click.stop="toggleAll(index)"
                                                        :indeterminate="countIncluded(index)<satelliteGroup[index].length && countIncluded(index)!==0"
                                                        :input-value="countIncluded(index) === satelliteGroup[index].length"
                                                        :label="panelHeader[index]"
                                                ></v-checkbox>
                                            </div>
                                            <v-spacer />
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <div style="margin: 7px 0px 7px 4px;display: flex;flex-wrap: wrap;">
                                                <div v-for="item in satelliteGroup[index]" :key="item.name" style="width: 33%;">
                                                    <v-checkbox
                                                            v-model="tempSatelliteSelect" :label="item.name" :value="item.value"
                                                            hide-details style="margin-top: 0px;"
                                                    ></v-checkbox>
                                                </div>
                                            </div>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                                <div style="display: flex;justify-content: center;width: 100%;">
                                    <v-btn
                                            width="65" height="25" @click="confirmSatellite"
                                            style="margin: 8px 43px 10px 0px;background-color: #08A9AE;color: #FFFFFF;font-size: 12px;"
                                    >确定</v-btn>
                                    <v-btn
                                            outlined width="65" height="25" @click="resetSatellite"
                                            style="margin: 8px 0px 10px;color: #08A9AE;font-size: 12px;"
                                    >重置</v-btn>
                                </div>
                            </v-tab-item>
                            <!--  选择时间  -->
                            <v-tab-item>
                                <v-radio-group row v-model="dateClass">
                                    <v-radio label="拍摄时间" value="imagingTime" style="width: 44%;margin-left: 2.5%;"></v-radio>
                                    <v-radio label="交付时间" value="deliveryTime" style="width: 44%;padding-left: 1.5%;"></v-radio>
                                </v-radio-group>
                                <div id="deliveryTime" class="time-style" data-app style="margin-bottom: 5px;">
                                    <v-menu
                                            ref="menuPhotoStartDate" v-model="menuPhotoStartDate" :close-on-content-click="false"
                                            absolute :position-x="photo_start_x" :position-y="photo_start_y"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <div style="width: 40%;">
                                                <v-text-field
                                                        v-model="tempPhotoStartDate" hide-details clearable label="起始时间" v-bind="attrs" v-on="on"
                                                ></v-text-field>
                                            </div>
                                        </template>
                                        <v-date-picker v-model="tempPhotoStartDate" no-title scrollable @change="savePhotoStartDate"></v-date-picker>
                                    </v-menu>
                                    <v-icon style="margin-top: 4px;">mdi-minus</v-icon>
                                    <v-menu
                                            ref="menuPhotoEndDate" v-model="menuPhotoEndDate" :close-on-content-click="false"
                                            absolute :position-x="photo_end_x" :position-y="photo_end_y"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <div style="width: 40%;">
                                                <v-text-field
                                                        v-model="tempPhotoEndDate" hide-details clearable label="截止时间" v-bind="attrs" v-on="on"
                                                ></v-text-field>
                                            </div>
                                        </template>
                                        <v-date-picker v-model="tempPhotoEndDate" no-title scrollable @change="savePhotoEndDate"></v-date-picker>
                                    </v-menu>
                                </div>
                                <div style="display: flex;justify-content: center;">
                                    <v-btn
                                            width="65" height="25" @click="confirmDeliveryTime"
                                            style="margin: 8px 43px 10px 0px;background-color: #08A9AE;color: #FFFFFF;font-size: 12px;"
                                    >确定</v-btn>
                                    <v-btn outlined width="65" height="25" @click="resetDeliveryTime" style="margin: 8px 0px 10px;color: #08A9AE;font-size: 12px;">重置</v-btn>
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tab-item>
                    <!-- 查找 -->
                    <v-tab-item>
                        <v-menu
                                ref="menuKeyword" v-model="menuKeyword" :close-on-content-click="false"
                                absolute :position-x="photo_search_x" :position-y="photo_search_y"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <div>
                                    <v-text-field
                                            v-model="searchDelivery" label="文件/切片名称或需求ID" style="width: 96%;margin: 0px 2%;" clearable v-on="on" v-bind="attrs"
                                    ></v-text-field>
                                </div>
                            </template>
                            <v-card id="searchDelivery" class="scrollbar" style="width: 405px;max-height: 400px;overflow: auto;" @scroll="scrollCheck($event)">
                                <div v-if="!searchDelivery || noneSearchResult" style="display: flex;flex-direction: column;align-items: center;height: 200px;">
                                    <img src="/dataLab/影视库搜索无结果.png" style="width: 85px;height: 59px;margin: 25px 0px;">
                                    <div style="color: #757575;font-size: 14px;">很抱歉，没有匹配到内容</div>
                                </div>
                                <v-list v-else>
                                    <v-list-item
                                            dense style="min-height: 30px;"
                                            v-for="item in searchList" :key="item.productCode" @click="selectProduct(item)"
                                    >
                                        <img v-if="item.dataType===1" src="/gallery/压缩包.png" style="width: 18px;height: 14px;">
                                        <img v-else-if="item.dataType===2" src="/gallery/切片图标.png" style="width: 18px;height: 14px;">&nbsp;&nbsp;
                                        <div style="font-size: 12px;">{{item.productName}}</div>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-menu>
                    </v-tab-item>
                    <!-- 对比 -->
                    <v-tab-item class="display_flex">
                        <div class="div-out" >
                            <div class="div-line" :style="{'background-color':lineScreenColor}"></div>
                            <div  class="div-img-out" @click="switchMode('screen')">
                                <img :src="'/dataLab/分屏(灰).png'"  v-show="$store.state.compare.compareShowMode !== 'screen'"/>
                                <img :src="'/dataLab/分屏.png'"  v-show="$store.state.compare.compareShowMode === 'screen'"/>
                                <label class="compare-label">分屏</label>
                            </div>
                            <div class="selectCompare-radioLine">
                                <label class="selectCompare-roller-radioItem">
                                    <input type="radio" v-model="selectRadio" id="screen2" value="二分屏"
                                        @click="switchScreen(2)"/>
                                    <label for="screen2" class="selectCompare-radioLabel">二分屏</label>
                                </label>
                                <label class="selectCompare-roller-radioItem">
                                    <input type="radio" v-model="selectRadio" id="screen4" value="四分屏"
                                        @click="switchScreen(4)"/>
                                    <label for="screen4" class="selectCompare-radioLabel">四分屏</label>
                                </label>
                            </div>
                        </div>
                        <div class="div-out" >
                            <div class="div-line" :style="{'background-color':lineRollerColor}"></div>
                            <div  class="div-img-out" @click="switchMode('roller')">
                                <img :src="'/dataLab/卷帘(灰).png'"  v-show="$store.state.compare.compareShowMode !== 'roller'"/>
                                <img :src="'/dataLab/卷帘.png'"  v-show="$store.state.compare.compareShowMode === 'roller'"/>
                                <label class="compare-label">卷帘</label>
                            </div>
                            <div class="selectCompare-radioLine">
                                <label class="selectCompare-roller-radioItem">
                                    <input type="radio" v-model="selectRadio" id="rollerHorizon" value="左右卷帘" @click="switchRoll(false)"/>
                                    <label for="rollerHorizon" class="selectCompare-radioLabel">左右卷帘</label>
                                </label>
                                <label class="selectCompare-roller-radioItem">
                                    <input type="radio" v-model="selectRadio" id="rollerVertical" value="上下卷帘" @click="switchRoll(true)"/>
                                    <label for="rollerVertical" class="selectCompare-radioLabel">上下卷帘</label>
                                </label>
                            </div>
                        </div>
                    </v-tab-item>
                    <div :style="{height: 'calc(100% - '+galleryHeight+'px'}">
                        <div v-show="$store.state.noneDelivery" style="display: flex;flex-direction: column;align-items: center;">
                            <img src="/dataLab/搜索无结果.png" style="width: 200px;height: 110px;margin: 25px 0px;">
                            <div style="color: #F7F7F7;font-size: 14px;">很抱歉，该分类下没有相关搜索结果</div>
                        </div>
                        <div v-if="!$store.state.noneDelivery" class="delivery-style">
                            <!--  数据列表标题-->
                            <v-snackbar top v-model="snackbar" :color="snackbarColor" timeout="2000">{{snackbarInfo}}</v-snackbar>
                            <div class="homeLeftBarDataLabListTitle">
                                <p class="title-name">我的数据</p>
                                <div id="changeData" style="float: right;display: flex;">
                                    <!--  切片按钮  -->
                                    <p style="font-size: 12px;color: #F3EFEF;margin: 4px 4px 0px 0px;">仅看切片</p>
                                    <div @click="changeIsLayer">
                                        <img v-show="isLayer" src="../../assets/开.png" style="width: 25px;height: 13px;margin-top: 2px;">
                                        <img v-show="!isLayer" src="../../assets/关.png" style="width: 25px;height: 13px;margin-top: 5px;">
                                    </div>
                                    <!--  排序按钮  -->
                                    <v-menu offset-x @input="changeSort">
                                        <template v-slot:activator="{on, attrs}">
                                            <img src="../../assets/排序.png" class="sort-img" v-on="on" v-bind="attrs">
                                        </template>
                                        <v-tabs id="sort" vertical v-model="sort" hide-slider>
                                            <v-tab style="height: 24px;font-size:12px;margin-top: 4px;"><v-icon x-small v-show="sort===0">mdi-checkbox-blank-circle</v-icon>&nbsp;按名称正序</v-tab>
                                            <v-tab style="height: 24px;font-size:12px;"><v-icon x-small v-show="sort===1">mdi-checkbox-blank-circle</v-icon>&nbsp;按名称倒序</v-tab>
                                            <v-tab style="height: 24px;font-size:12px;"><v-icon x-small v-show="sort===2">mdi-checkbox-blank-circle</v-icon>&nbsp;按更新时间正序</v-tab>
                                            <v-tab style="height: 24px;font-size:12px;margin-bottom: 4px;"><v-icon x-small v-show="sort===3">mdi-checkbox-blank-circle</v-icon>&nbsp;按更新时间倒序</v-tab>
                                        </v-tabs>
                                    </v-menu>
                                </div>
                            </div>
                            <vuescroll :ops="ops" style="height: calc(100% - 24px);width: 100%;top: -10px;">
                                <!--            数据列表区域-->
                                <div id="dataList">
                                    <v-treeview
                                            dense open-on-click selectable v-model="layerOverlay" :load-children="loadChildren"
                                            activatable color="#329999" :active.sync="section" :open.sync="sidebarOpenList"
                                            :items="deliveryDataList" style="font-size: 14px;"
                                    >
                                        <template v-slot:prepend="{ item }">
                                            <img v-if="item.type==='folder'" src="/gallery/文件夹-展开.png" style="width: 20px;height: 16px;">
                                            <img v-else-if="item.packageOperation==false" src="/gallery/其他需求不打包.png" style="margin-left: 4px;width: 18px;margin-top: 5px;height: 18px;">
                                            <img v-else-if="item.dataType===1" src="/gallery/压缩包.png" style="margin-left: 4px;width: 18px;margin-top: 5px;height: 18px;">
                                            <img v-else-if="item.dataType===2" src="/gallery/切片图标.png" style="margin-top: 4px;width: 20px;height: 16px;">
                                        </template>
                                        <template v-slot:label="{ item }">
                                            <div
                                                    class="list-item-name"
                                                    draggable="true" @dragstart="dragstart(item)"
                                                    @mouseenter="focusItem=item.id" @mouseleave="focusItem=''"
                                            >
                                                <div class="list-item-name-label">
                                                    {{ item.name }} <span v-if="item.type==='folder'&&item.selectedNum!==undefined">( {{item.selectedNum}}</span>
                                                    <span v-if="item.type==='folder'&&!isLayer"> / {{item.productNum}} )</span>
                                                    <span v-else-if="item.type==='folder'&&isLayer"> / {{item.layerNum}} )</span>
                                                </div>
                                                <v-menu offset-x open-on-hover>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <img
                                                                v-show="item.id===focusItem" src="../../assets/操作.png" v-on="on" v-bind="attrs"
                                                                @mouseenter="menuList=item"
                                                        >
                                                    </template>
                                                    <div @mouseenter="focusItem=menuList.id" @mouseleave="focusItem=''">
                                                        <v-list v-if="menuList.type==='folder'" style="font-size: 12px;">
                                                            <v-list-item style="min-height: 25px;" class="item-icon-menu" @click="downloadAll(menuList)">批量下载</v-list-item>
                                                            <v-list-item style="min-height: 25px;" class="item-icon-menu" @click="arrangeFile(menuList.id)">整理文件</v-list-item>
                                                        </v-list>
                                                        <v-list dense v-else-if="menuList.dataType===1" style="font-size: 12px;">
                                                            <v-list-item style="min-height: 25px;" class="item-icon-menu" @click="showDeliveryDetail($event, menuList)">查看详情</v-list-item>
                                                            <v-list-item v-if="item.fileType!='dir'" style="min-height: 25px;" class="item-icon-menu" @click="download(menuList)">下载文件</v-list-item>
                                                            <v-list-item style="min-height: 25px;" @click="arrangeFile(menuList.id)">整理文件</v-list-item>
                                                        </v-list>
                                                        <v-list dense v-else-if="menuList.dataType===2" style="font-size: 12px;">
                                                            <v-list-item style="min-height: 25px;" class="item-icon-menu" @click="showDeliveryDetail($event, menuList)">查看详情</v-list-item>
                                                            <v-list-item style="min-height: 25px;" class="item-icon-menu" @click="arrangeFile(menuList.id)">整理文件</v-list-item>
                                                        </v-list>
                                                    </div>
                                                </v-menu>
                                            </div>
                                        </template>
                                    </v-treeview>
                                </div>
                            </vuescroll>
                        </div>
                    </div>
                    <v-progress-linear
                            v-if="isDeliveryLoading" absolute indeterminate light color="#374C53"
                            style="bottom: 40px;background:#ffffff;height: 6px"
                    ></v-progress-linear>
                </v-tabs-items>
            </v-tab-item>
            <v-tab-item style="height: calc(100% - 50px)">
                <v-toolbar flat height="40">
                    <!--  订单中心一级子功能UI: 筛选，查找  -->
                    <v-tabs fixed-tabs v-model="orderFunc" background-color="#2F4249" @change="changeOrderFunc">
                        <v-tabs-slider style="width: 85%;margin: 0px 7.5%;"></v-tabs-slider>
                        <v-tab v-for="order in orderTabs" :key="order.tab">
                            <img
                                    :src="order.srcWhite" style="margin: 10px 8px;"
                                    :style="{
                                        filter: order===orderTabs[orderFunc]?'none':'brightness(50%)',
                                        width: order.width+'px', height: order.height+'px'
                                    }"
                            >
                            {{ order.tab }}
                        </v-tab>
                    </v-tabs>
                </v-toolbar>
                <!-- 任务n: 写这个tabs-item特有的多选项，用v-select -->
                <v-tabs-items id="orderItem" dark v-model="orderFunc" style="height: 100%">
<!--                    筛选-->
                    <v-tab-item>
                        <v-toolbar flat>
                            <!--  订单中心二级子功能UI：订单状态，订单类型，成像模式，下单时间  -->
                            <v-tabs hide-slider v-model="optionTab">
                                <v-tab v-for="opt in optionTabs" :key="opt.tab" style="padding: 0px 5.5px;" @click="showTabs(optionTabs[optionTab].tab, opt.tab, optionTabs)">
                                    <div>
                                        <img
                                                :src="opt.srcWhite" style="margin: 13px 8px;"
                                                :style="{
                                                    filter: !showLevel4||(showLevel4&&opt.show)?'none':'brightness(50%)',
                                                    width: opt.tab==='下单时间'? '16px': '19px', height: opt.tab==='下单时间'? '16px': '19px',
                                                }"
                                        >
                                    </div>
                                    <div>
                                        <span :style="{color: !showLevel4||(showLevel4&&opt.show)?'white':'gray'}">{{ opt.tab }}</span><br>
                                        <span :style="{color: opt.show?'#329999':'gray'}">{{ opt.text }}</span>
                                    </div>
                                </v-tab>
                            </v-tabs>
                        </v-toolbar>
                        <v-tabs-items id="filter" dark v-model="optionTab" v-if="showLevel4">
                            <!--  订单状态  -->
                            <v-tab-item>
                                <v-radio-group row v-model="orderStatus" style="margin-top: 0px;margin-left: 10px;" @change="changeOrderStatus">
                                    <v-radio
                                            v-for="(item, index) in orderStatusOptions" :key="index" :label="item.label" :value="item.value" style="width: 20%;"
                                    ></v-radio>
                                </v-radio-group>
                            </v-tab-item>
                            <!--  订单类型  -->
                            <v-tab-item>
                                <v-radio-group
                                        row style="margin-top: 0px;margin-left: 10px;"
                                        v-model="orderTypeSelected" @change="changeOrderTypeSelected"
                                >
                                    <v-radio
                                            v-for="(item, index) in orderTypeOptions" :key="index" :label="item.label" :value="item.value"  style="width: 29%;"
                                    ></v-radio>
                                </v-radio-group>
                            </v-tab-item>
                            <!--  成像模式  -->
                            <v-tab-item>
                                <v-radio-group
                                        row style="margin-top: 0px;margin-left: 10px;"
                                        v-model="productTypeSelected" @change="changeProductTypeSelected"
                                >
                                    <v-radio
                                            v-for="(item, index) in productTypeOptions" :key="index" :label="item.label" :value="item.value"  style="width: 20%;"
                                    ></v-radio>
                                </v-radio-group>
                            </v-tab-item>
                            <!--  下单时间  -->
                            <v-tab-item class="time-style" data-app="true" style="margin-top: 10px;margin-bottom: 5px;">
                                <v-menu
                                        ref="menuStartDate" v-model="menuStartDate" :close-on-content-click="false"
                                        absolute :position-x="start_x" :position-y="start_y"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <div style="width: 40%;">
                                            <v-text-field
                                                    v-model="startDate" hide-details clearable label="起始时间" v-bind="attrs" v-on="on"
                                            ></v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="startDate" no-title scrollable @change="saveStartDate"></v-date-picker>
                                </v-menu>
                                <v-icon style="margin-top: 4px;">mdi-minus</v-icon>
                                <v-menu
                                        ref="menuEndDate" v-model="menuEndDate" :close-on-content-click="false"
                                        absolute :position-x="end_x" :position-y="end_y"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <div style="width: 40%">
                                            <v-text-field
                                                    v-model="endDate" hide-details clearable label="截止时间" v-bind="attrs" v-on="on"
                                            ></v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="endDate" no-title scrollable @change="saveEndDate"></v-date-picker>
                                </v-menu>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tab-item>
<!--                    查找-->
                    <v-tab-item>
                        <v-text-field
                                v-model="searchID" label="订单号或需求名" style="width: 96%;margin: 0px 2%;" clearable
                                append-icon="mdi-magnify" @click:append="orderClick"
                        ></v-text-field>
                    </v-tab-item>
                    <div class="order-title-name">
                        <div style="display: flex;"><div class="green-line"></div><p>订单列表</p></div>
                        <div style="color: #A2A2A2;font-size: 12PX;margin: 4px 12px;">已加载 {{loadingOrderNum}} 项 / 共 {{orderTotal}} 项</div>
                    </div>
                    <div :style="{height: 'calc(100% - '+orderHeight+'px)'}">
                        <div v-if="!noneOrder" class="order-list" @scroll="scrollPanel" >
                            <v-list style="padding: 0px;">
                                <v-list-item v-for="(item, index) in recordsList" :key="index" class="list-item-style">
                                    <div class="content">
                                        <div :style="{ 'float': 'right', 'color': getDemandStateColor(item.demandState) }" style="font-size: 10px;">{{getDemandState(item.demandState)}}</div>
                                        <div><b>名称</b>：{{item.requestName}}</div>
                                        <div style="display: flex;justify-content: space-between;">
                                            <div>
                                                <div><b>ID</b>：{{item.demandId}}</div>
                                                <div><b>类型</b>：{{orderTypeOptionList[item.orderType]}}</div>
                                            </div>
                                            <div>
                                                <div><b>时间</b>：{{item.createTime}}</div>
                                                <div v-if="item.productType"><b>模式</b>：{{productTypeOptionDict[item.productType]}}</div>
                                            </div>
                                        </div>
                                        <v-btn
                                                small width="93" height="27" @click="showOrderDetail($event, item, 0)"
                                                style="color: #329999;border: 1px solid #329999;font-size: 10px;margin-top: 5px;margin-right: 30px;"
                                        >订单详情</v-btn>
                                        <v-btn
                                                small v-show="item.deliveryInfos.length!==0" width="93" height="27" @click="showOrderDetail($event, item, 1)"
                                                style="background-color: #329999;font-size: 10px;margin-top: 5px;margin-right: 30px;"
                                        >交付列表</v-btn>
                                        <v-btn
                                                small v-show="item.deliveryInfos.length!==0 && (!item.dataDeleted || (item.dataDeleted && item.isTile))"
                                                @click="showGallery(item.demandId)" width="93" height="27"
                                                style="color: #329999;border: 1px solid #329999;font-size: 10px;margin-top: 5px;"
                                        >管理数据</v-btn>
                                    </div>
                                    <v-divider style="width: 100%;margin-left: 2%;margin-top: 3px;background-color: #374C53"></v-divider>
                                </v-list-item>
                            </v-list>
                        </div>
                        <div v-show="noneOrder" style="display: flex;flex-direction: column;align-items: center;">
                            <img src="/dataLab/搜索无结果.png" style="width: 200px;height: 110px;margin: 25px 0px;">
                            <div style="color: #F7F7F7;font-size: 14px;">很抱歉，该分类下没有相关搜索结果</div>
                        </div>
                    </div>
                    <v-progress-linear
                            v-if="isOrderLoading" absolute indeterminate light color="#374C53" style="bottom: 40px;background:#ffffff;height: 6px"
                    ></v-progress-linear>
                </v-tabs-items>
                <!-- 任务n: 创建一个新文件，用于写订单中心的子页面，记得向双播要pan的git -->
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    import turf from "turf";
    import vuescroll from 'vuescroll';
    import WKT from "terraformer-wkt-parser";

    export default {
        name: "Sidebar",
        components: {
            vuescroll,
        },
        data() {
            return {
                encryption:false,
                isDeliveryLoading: false,
                isOrderLoading: false,
                tabs: [], noneOrder: false,
                recordsList: [],       // 从后台获取的订单列表
                orderTotal: 0,         // “订单中心”列表的总订单数
                loadingOrderNum: 0,    // “订单中心”列表的已加载订单数
                orderPageNum: 1,
                orderPageMax: 1,
                dateClass: "imagingTime",
                galleryTabs: [
                    { tab: "浏览", srcWhite: "/dataLab/浏览(白).png", width: 17, height: 11, childHeight: 64 },
                    { tab: "查找", srcWhite: "/dataLab/查找(白).png", width: 13, height: 13, childHeight: 66 },
                    { tab: "对比", srcWhite: "/dataLab/对比(白).png", width: 13, height: 14, childHeight: 64 },
                ],
                galleryBrowser: 0, browserTabs: [
                    { tab: "数据类型", srcWhite: "/dataLab/筛选器-数据类型.png", text: "全部", show: true, childHeight: 80 },
                    { tab: "成像卫星", srcWhite: "/dataLab/筛选器-成像卫星.png", text: "全部", show: true, childHeight: 180 },
                    { tab: "时间", srcWhite: "/dataLab/筛选器-拍摄时间.png", text: "全部", show: true, childHeight: 132 },
                ],
                dataTypeSelect: ["IMAGE", "MULTISPECTRAL", "NIGHT", "VIDEO", "LPB", "STERO", "OTHER", "OFFLINE"],
                tempDataTypeSelect: ["IMAGE", "MULTISPECTRAL", "NIGHT", "VIDEO", "LPB", "STERO", "OTHER", "OFFLINE"],
                dataTypeList: [
                    { label: '普通光学', value: 'IMAGE' }, { label: '多光谱', value: 'MULTISPECTRAL' }, { label: '夜光', value: 'NIGHT' },
                    { label: '卫星视频', value: 'VIDEO' }, { label: '编程推扫', value: 'LPB' }, { label: '立体', value: 'STERO' },
                    { label: "线下订单", value: "OFFLINE"}, { label: '其他数据', value: 'OTHER' }
                ],
                expansionIndex: [],
                tempSatelliteSelect: [
                    "JL101A", "JL103B", "JL104B", "JL105B", "JL106B", "JL107B", "JL108B", "JL101C", "JL102C", "JL101D", "JL101E", "JL102E",
                    "JL101K", "JL1GF03B01", "JL1GF03B02", "JL1GF03B03", "JL1GF03B04", "JL1GF03B05", "JL1GF03B06", "JL1GF03C01", "JL1GF03C02",
                    "JL1GF03C03"
                ],
                satelliteSelect: [
                    "JL101A", "JL103B", "JL104B", "JL105B", "JL106B", "JL107B", "JL108B", "JL101C", "JL102C", "JL101D", "JL101E", "JL102E",
                    "JL101K", "JL1GF03B01", "JL1GF03B02", "JL1GF03B03", "JL1GF03B04", "JL1GF03B05", "JL1GF03B06", "JL1GF03C01", "JL1GF03C02",
                    "JL1GF03C03"
                ],
                satelliteGroup:[  // 这里孟欣需要跟生产系统对接，所以我需要使用使用旧的卫星对应表
                    [
                        { name:'光学A星(0.72m)', value:'JL101A' }, { name:'高分02A星(0.75m)', value:'JL101E' },
                        { name:'高分02B星(0.75m)', value:'JL102E' }, { name:'宽幅01A星(0.75m)', value:'JL101K' },
                    ],
                    [
                        {name:'视频03星(0.92m)', value:'JL103B'}, {name:'视频04星(0.92m)', value:'JL104B'}, {name:'视频05星(0.92m)', value:'JL105B'},
                        {name:'视频06星(0.92m)', value:'JL106B'}, {name:'视频07星(0.92m)', value:'JL107B'}, {name:'视频08星(0.92m)', value:'JL108B'},
                        {name:'高分03A星(1m)', value:'JL101D'}, {name:'高分03B01星(1m)', value:'JL1GF03B01'}, {name:'高分03B02星(1m)', value:'JL1GF03B02'},
                        {name:'高分03B03星(1m)', value:'JL1GF03B03'}, {name:'高分03B04星(1m)', value:'JL1GF03B04'}, {name:'高分03B05星(1m)', value:'JL1GF03B05'},
                        {name:'高分03B06星(1m)', value:'JL1GF03B06'}, {name:'高分03C01星(1m)', value:'JL1GF03C01'}, {name:'高分03C02星(1m)', value:'JL1GF03C02'},
                        {name:'高分03C03星(1m)', value:'JL1GF03C03'},
                    ],
                    [ {name:'光谱01星(5m)', value:'JL101C'}, {name:'光谱02星(5m)', value:'JL102C'} ]
                ],
                panelHeader: ['优于0.75m','0.92m - 1.1m','5m'],
                menuPhotoStartDate: false, menuPhotoEndDate: false,
                orderFunc: 0, orderTabs: [
                    { tab: "筛选", srcWhite: "/dataLab/筛选.png", width: 17, height: 15, childHeight: 64 },
                    { tab: "查找", srcWhite: "/dataLab/查找(白).png", width: 13, height: 13, childHeight: 66 },
                ],
                optionTab: 0, optionTabs: [
                    { tab: "订单状态", srcWhite: "/dataLab/状态.png", text: "全部", show: true, childHeight: 36 },
                    { tab: "订单类型", srcWhite: "/dataLab/类型.png", text: "全部", show: true, childHeight: 64 },
                    { tab: "成像模式", srcWhite: "/dataLab/成像.png", text: "全部", show: true, childHeight: 64 },
                    { tab: "下单时间", srcWhite: "/dataLab/筛选器-拍摄时间.png", text: "全部", show: true, childHeight: 59 }
                ],
                selectRadio: "二分屏", lineScreenColor:'#009999', lineRollerColor: "#9797974C",
                orderFilter: 0,
                orderStatus: "3",
                orderStatusOptions: [ { label: '全部', value: '3' }, { label: '已完成', value: '1' }, { label: '进行中', value: '0' } ],
                orderTypeSelected: "4",
                orderTypeOptions: [
                    { label: '全部', value: '4' }, { label: '标准景', value: '0' },
                    { label: '点编程', value: '1' }, { label: '大区域编程', value: '3' }, { label: '其他', value: '2' },
                ],
                productTypeSelected: "ALL",
                productTypeOptions: [
                    { label: '全部', value: 'ALL' }, { label: '普通光学', value: 'IMAGE' },
                    { label: '夜光', value: 'NIGHT' }, { label: '视频', value: 'VIDEO' },
                    { label: '多光谱', value: 'MULTISPECTRAL' }, { label: '推扫', value: 'LPB' },
                    { label: '立体', value: 'STERO' },
                ],
                showLevel4: false,
                searchID: "", menuKeyword: false, orderSearchClickable: true,
                searchDelivery: "", currentPage: 1, searchTotalPages: 1, searchList: [],
                photo_start_x: 10, photo_start_y: 240, photo_end_x: 120, photo_end_y: 240, photo_search_x: 10, photo_search_y: 150,
                start_x: 10, start_y: 210, end_x: 120, end_y: 210,
                startDate: "", menuStartDate: false, endDate: "", menuEndDate: false,
                galleryHeight: 104, galleryBaseHeight: 40, orderHeight: 129, orderBaseHeight: 129,
                noneSearchResult: false,
                compareResult: [],
                layerOverlay: [], layerIdDict: {},
                snackbar: false, snackbarInfo: "", snackbarColor: "",
                sort: 3,
                focusItem: "",
                menuList: {},
                rootId: "",      // 保存‘我的数据’的ID
                selfItem: "",  // 传递给数据管理的自己的数据
                searchItemObject: {},
                position: 0,
                deliveryDataList: [],  // 侧边栏影视库的列表数据
                productTypes: null,
                satelliteIds: null,
                tempPhotoStartDate: null,  // 临时保存时间下的选择
                tempPhotoEndDate: null,
                photoStartDate: null,      // 最终传给后台的确定性时间
                photoEndDate: null,
                sidebarOpenList: [],
                section: [],
                searchRoot: [],   // 影像库的查找功能，在点击之后用于查找到的保存树形层级
                searchPath: [],   // 影像库的查找功能，在点击之后用于保存需要展开的路径
                searchProductCode: "",  // 影像库的查找功能，在点击之后用于保存产品ID
                downloadList: [],
                num: 0,
                isLayer: false,   // 控制是否只获取切片数据
                productList: [],
                demandDetailId: "",
                requestTime: new Date(),
                // 以下是字典
                orderTypeOptionList: [ "标准景需求", "点编程需求", "其他需求", "大区域需求" ],
                demandStateColorDict: { "9": "#329999", "1": "#CF736E", "20": "#CF736E", },
                productTypeOptionDict: {
                    "IMAGE": "普通光学", "NIGHT": "夜光", "VIDEO": "视频", "MULTISPECTRAL": "多光谱",
                    "LPB": "推扫", "STERO": "立体", "OFFLINE": "线下订单"
                },
                ops: {
                    bar: {
                        onlyShowBarOnScroll: false,
                        background: "#374C53"
                    }
                },
                imagingModeOptions: {
                    "LPB": "常规推扫", "SA": "夜光", "SD": "凝视视频", "SD_STERO": "立体成像"
                },
                projectionOptions: {
                    "WGS84$UTM_ZONE_6": "WGS84+UTM投影6°", "WGS84$GEOS_ZONE_6": "WGS84+经纬投影",
                    "CGCS2000$GAUSS_ZONE_6": "CGCS2000+高斯克吕格6°带", "CGCS2000$GAUSS_ZONE_3": "CGCS2000+高斯克吕格3°带"
                },
                satelliteNewList: {
                    "JL101A": "光学A星", "JL103B": "视频03星", "JL104B": "视频04星", "JL105B": "视频05星", "JL106B": "视频06星",
                    "JL107B": "视频07星", "JL108B": "视频08星", "JL1GP01": "光谱01星", "JL1GP02": "光谱02星", "JL1GF02A": "高分02A星",
                    "JL1GF02B": "高分02B星", "JL1KF01A": "宽幅01A星", "JL1GF03A": "高分03A星", "JL1GF03B01": "高分03B01星",
                    "JL1GF03B02": "高分03B02星", "JL1GF03B03": "高分03B03星", "JL1GF03B04": "高分03B04星", "JL1GF03B05": "高分03B05星",
                    "JL1GF03B06": "高分03B06星", "JL1GF03C01": "高分03C01星", "JL1GF03C02": "高分03C02星", "JL1GF03C03": "高分03C03星",
                },
                productTypeOptionsDict: {
                    "IMAGE": "普通光学", "NIGHT": "夜光", "VIDEO": "视频", "MULTISPECTRAL": "多光谱", "LPB": "推扫", "STERO": "立体",
                },
            };
        },
        watch: {
            searchDelivery(newVal){
                if (!newVal) {
                    this.menuKeyword = false;
                } else {
                    this.currentPage = 1;
                    this.menuKeyword = true;
                    this.searchList = [];
                    this.searchKeyword(newVal);
                }
            },
            galleryBrowser(newVal){
                // “影像库——浏览”下的的tab切换时触发，此处需要使option设置为与下面列表使用的一致的
                // 设置“时间”与列表使用的保持一致
                this.tempPhotoStartDate = this.photoStartDate;
                this.tempPhotoEndDate = this.photoEndDate;
                if (this.tempPhotoStartDate || this.tempPhotoEndDate) {
                    this.browserTabs[2].text = "已设置";
                } else {
                    this.browserTabs[2].text = "全部";
                }
                // 设置“数据类型”与列表使用的保持一致
                this.tempDataTypeSelect = this.dataTypeSelect;
                if (this.dataTypeSelect.length === 8) {
                    this.browserTabs[0].text = "全部";
                    this.productTypes = null;
                } else if (this.dataTypeSelect.length === 0) {
                    this.browserTabs[0].text = "未选择";
                    this.productTypes = "";
                } else {
                    this.browserTabs[0].text = "部分选择";
                    this.productTypes = this.dataTypeSelect.join(",");
                }
                // 设置“成像卫星”与列表使用的保持一致
                this.tempSatelliteSelect = this.satelliteSelect.slice(0);
                if (this.satelliteSelect.length === 22) {
                    this.browserTabs[1].text = "全部";
                    this.satelliteIds = null;
                } else if (this.satelliteSelect.length === 0) {
                    this.browserTabs[1].text = "未选择";
                    this.satelliteIds = "";
                } else {
                    this.browserTabs[1].text = "部分选择";
                    this.satelliteIds = this.satelliteSelect.join(",");
                }
                // 处理“影像库”列表高度
                if (this.showLevel4){
                    this.galleryHeight = this.galleryBaseHeight + this.browserTabs[newVal].childHeight;
                }
            },
            optionTab(newVal){
                if (this.showLevel4){
                    this.orderHeight = this.orderBaseHeight + this.optionTabs[newVal].childHeight;
                }
            },
            showLevel4(newVal){
                if (newVal) {
                    this.galleryHeight = this.galleryBaseHeight + this.browserTabs[this.galleryBrowser].childHeight;
                    this.orderHeight = this.orderBaseHeight + this.optionTabs[this.optionTab].childHeight;
                } else {
                    this.galleryHeight = this.galleryBaseHeight = 40 + this.galleryTabs[this.$store.state.myLabFucChecked].childHeight;
                    this.orderHeight = this.orderBaseHeight = 65 + this.orderTabs[this.orderFunc].childHeight;
                    this.optionTabs.forEach(item => {
                        item.show = true;
                    })
                    this.browserTabs.forEach(item => {
                        item.show = true;
                    })
                }
            },
            searchID(newVal){
                if (newVal === null) {
                    // 只有点击搜索按钮才能进入searchID处理，由查找切换到筛选不可以
                    this.initSet();  // 监控关键字以便在数据为空时做初始化
                }
            },
            async section(newVal) {
                // 本func用于处理点击时zoom到需要的位置
                if (newVal[0]) {
                    // 下面的替换为广度遍历，目的是为了找到需要的GEO
                    this.breadthFirstSearch(newVal[0], this.deliveryDataList);
                    if (this.searchItemObject.dataType === 2) {
                        await this.getLayerData(this.searchItemObject);
                        this.zoomGeo(this.searchItemObject.dataGeojson);  // 飞过去
                    }
                }
            },
            async layerOverlay(newVal, oldVal) {
                if (newVal.length > oldVal.length) {
                    // 场景三：未勾选条件下，勾选切片数据
                    // 场景四：未勾选条件下，勾选文件夹数据，文件夹内部只有一个切片，并没有其他文件夹，则第一次的文件夹经过这里
                    // 场景五：未勾选条件下，勾选文件夹，其内部有2个及以上切片
                    let newLayerIdList = this.compareArray(newVal, oldVal);
                    let count = 0;  // 记录实际有的新增切片数量
                    for (const id of newLayerIdList) {
                        this.breadthFirstSearch(id, this.deliveryDataList);
                        if(this.searchItemObject.dataType===2){
                            count += 1;
                            if (this.searchItemObject.dataGeojson) {
                                this.layerIdDict[id] = this.utils.addCesiumLayer(this.searchItemObject.serviceUrl, this.searchItemObject.dataGeojson);
                            } else {
                                await this.getLayerData(this.searchItemObject);
                            }
                        }
                    }
                    if (count === 1) {
                       this.zoomGeo(this.searchItemObject.dataGeojson);  // 飞过去
                    }
                } else if (newVal.length === oldVal.length) {
                    // 场景一：点击切片label，由section触发的, layerOverlay()此时是新旧数组 长度相等&&内容相同，此时section已经处理完毕，没有新增图层
                    // 场景四：未勾选条件下，勾选文件夹数据，文件夹内部只有一个切片，并没有其他文件夹，则文件夹加载的子项经过这里，内容不同
                    let newLayerIdList = this.compareArray(newVal, oldVal);  // 用这个区分一二场景
                    if (newLayerIdList.length === 1) {  // 场景二
                        this.breadthFirstSearch(newLayerIdList[0], this.deliveryDataList);
                        if (this.searchItemObject.dataType===2) {
                            await this.getLayerData(this.searchItemObject);
                            this.zoomGeo(this.searchItemObject.dataGeojson);  // 飞过去
                        }
                    }
                } else {  // 删除图层，可满足删除一个或多个
                    let deleteLayerIdList = this.compareArray(newVal, oldVal);
                    for (const productCode of deleteLayerIdList) {
                        this.breadthFirstSearch(productCode, this.deliveryDataList);
                        if(this.searchItemObject.dataType===2){
                            let deleteLayer = this.layerIdDict[productCode];
                            window.viewer.imageryLayers.remove(deleteLayer);
                            delete this.layerIdDict[productCode];
                        }
                    }
                }

                this.resetSelected(this.deliveryDataList);
                for(let diff of newVal){
                    this.findCurrentParents(diff,{children:this.deliveryDataList})
                }
            },
            sort(newVal){
                switch (newVal) {
                    case 0:
                        this.$store.state.sortByField = "name";
                        this.$store.state.sortDire = "asc";
                        break;
                    case 1:
                        this.$store.state.sortByField = "name";
                        this.$store.state.sortDire = "desc";
                        break;
                    case 2:
                        this.$store.state.sortByField = "time";
                        this.$store.state.sortDire = "asc";
                        break;
                    case 3:
                        this.$store.state.sortByField = "time";
                        this.$store.state.sortDire = "desc";
                        break;
                }
                this.initDeliveryData();
            },
            searchPath(newVal) {
                if (this.searchPath.length > 0 && !this.sidebarOpenList.includes(newVal[0])) {
                    // 计算第一层上面的文件夹对应的高度
                    for (let i = 0; i < this.searchRoot.length; i++) {     // 搜索这一层的所有数据
                        if (this.searchRoot[i].id === newVal[0]) {    // 找到文件夹
                            this.position += i * 30;
                            // 针对数据加载和数据选中的操作
                            if (this.searchRoot[i].children.length !== 0) {    // 存在数据时的操作
                                this.sidebarOpenList.push(newVal[0]);  // 展开文件夹
                                if (newVal.length > 1) {
                                    this.searchRoot = this.searchRoot[i].children;
                                    this.searchPath = newVal.slice(1, newVal.length);
                                } else {
                                    this.$set(this.section, 0, this.searchProductCode);  // 选中数据
                                    this.$nextTick( () => {
                                        // 设置影像库位置
                                        let scrollItem = document.getElementsByClassName("__panel")[0];
                                        if ( this.position <= scrollItem.scrollHeight - scrollItem.clientHeight ) {
                                            scrollItem.scrollTop = this.position;
                                        } else if ( this.position > scrollItem.scrollHeight - scrollItem.clientHeight ) {
                                            scrollItem.scrollTop = scrollItem.scrollHeight - scrollItem.clientHeight;
                                        }
                                    })
                                }
                            } else {
                                this.initDeliveryData(this.searchRoot[i].children, newVal[0]);
                                this.$nextTick( () => {
                                    // 设置影像库位置
                                    let scrollItem = document.getElementsByClassName("__panel")[0];
                                    if ( this.position <= scrollItem.scrollHeight - scrollItem.clientHeight ) {
                                        scrollItem.scrollTop = this.position;
                                    } else if ( this.position > scrollItem.scrollHeight - scrollItem.clientHeight ) {
                                        scrollItem.scrollTop = scrollItem.scrollHeight - scrollItem.clientHeight;
                                    }
                                })
                            }
                        }
                    }
                }
            },
            downloadList(newVal) {
                let index = newVal.length - 1;
                if (newVal.length!==0){
                    if (newVal[index].children.length !== 0){
                        this.getDownloadable(newVal[index].children, newVal[index].productNum);
                    }
                }
            },
            getDeliveryDetail(newVal) {
                if (!newVal) {
                    this.$store.state.deliveryDetail = { "id": "" };
                }
            },
            getDemandTabFunc(newVal){
                if (newVal === 1){
                    // 获取newVal=0时调用的变量，this.$store.state.record['demandId']
                    // 用this.recordsList查找这个数据，用demandId判断
                    for (const record of this.recordsList) {
                        if (record.demandId === this.$store.state.record.demandId) {
                            // 对数据进行修改
                            if (record.deliveryInfos.length !== 0){
                                for (const delivery of record.deliveryInfos) {
                                    if (delivery.fileSize >= 1073741824) {
                                      delivery.fileSize = (delivery.fileSize/1073741824).toFixed(2) + "GB";
                                    } else if (delivery.fileSize >= 1048576) {
                                      delivery.fileSize = (delivery.fileSize/1048576).toFixed(2) + "MB";
                                    } else if (delivery.fileSize >= 1024) {
                                      delivery.fileSize = (delivery.fileSize/1024).toFixed(2) + "KB";
                                    } else {
                                      delivery.fileSize = delivery.fileSize + "B";
                                    }


                                }
                            }
                            this.$store.state.deliveryDetail["deliveryInfos"] = record.deliveryInfos;
                            this.$store.state.deliveryDetail["dataDeleted"] = record.dataDeleted;
                            this.$store.state.deliveryDetail["requestName"] = record.requestName;  // 图像名称

                            // 直接对 Vuex state 进行赋值，但是加入安全检查
                            if (record.largeAreaDeliveryInfos !== undefined) {
                              this.$store.state.deliveryDetail["largeAreaDeliveryInfos"] = JSON.parse(JSON.stringify(record.largeAreaDeliveryInfos));
                            } else {
                              this.$store.state.deliveryDetail["largeAreaDeliveryInfos"] = {};
                            }

                            break;
                        }
                    }
                }
            },
            expansionIndex(newVal){
                // 设置成像卫星选择panel高度
                this.browserTabs[1].childHeight = 180;
                if (newVal.length !== 0) {
                    for (const idx of newVal) {
                        switch (idx) {
                            case 0:
                                this.browserTabs[1].childHeight += 70;
                                break;
                            case 1:
                                this.browserTabs[1].childHeight += 182;
                                break;
                            case 2:
                                this.browserTabs[1].childHeight += 42;
                                break;
                        }
                    }
                }
                if (this.showLevel4){
                    this.galleryHeight = this.galleryBaseHeight + this.browserTabs[1].childHeight;
                }
            }
        },
        computed: {
            ...mapGetters([ "getDemandTabFunc" ]),
        },
        mounted() {
            let that = this;
            this.axios.interceptors.request.use(function (config) {
                config.requestTime = new Date();
                that.requestTime = config.requestTime;
                return config;
            })
            this.eventVue.$on("showDelivery", () => {
                if (this.$store.state.myLabFucChecked !== 2) {
                    this.galleryHeight = this.galleryBaseHeight = 40 + this.galleryTabs[this.$store.state.myLabFucChecked].childHeight;
                    this.layerOverlay = [];
                    this.initDeliveryData();
                } else {
                    this.initDeliveryCompare();
                }
            } );
            this.initDeliveryData();  // 为保证订单中心的“管理数据”跳转到“影像库”时文件夹都已经加载出来了
            this.initSet();
        },
        methods: {
            resetSelected(children){
                for(let child of children){
                    if(child.type === 'folder'){
                        child.selectedNum = 0;
                        if(child.children !== undefined){
                            this.resetSelected(child.children)
                        }
                    }
                }
            },
            findCurrentParents(id, parent){
                let target = parent.children.find(function (e) {
                    return e.id===id
                });
                if(target===undefined){
                    for(let child of parent.children){
                        if(child.type==='folder'){
                            //遍历子文件夹
                            this.findCurrentParents(id, child);
                        }
                    }
                }else{
                    // 命中
                    target.selectedNum = 0;
                    if(target.type==='folder' && target.children.length===0 && target.parentPath){
                        target.selectedNum = target.productNum;
                        this.setParentSelected(target.selectedNum, target.parentPath)
                    } else if (target.type==="product" && target.parentPath){
                        this.setParentSelected(1, target.parentPath)
                    }
                }
            },
            setParentSelected(num, path){
                let cFolder = this.deliveryDataList;
                for(let i=0; i < path.length; i++){
                    let cId = path[i];
                    for(let f of cFolder){
                        if(f.id === cId){
                            f.selectedNum += num;
                            cFolder = f.children
                        }
                    }
                }
            },
            orderClick(){
                if (this.orderSearchClickable) {
                    this.orderSearchClickable = false;
                    this.initSet();
                }
            },
            initSet(){
                this.orderPageNum = 1;
                this.orderPageMax = 1;
                this.orderTotal = 0;       // “订单中心”列表的总订单数
                this.loadingOrderNum = 0;  // “订单中心”列表的已加载订单数
                this.$store.state.showDetail = false;
                this.$store.state.record = {};
                this.recordsList = [];
                return this.initData();
            },
            changeSidebar(){
                // 切换第一层tab“影像库”“订单中心”时触发
                // 重置影像库的设置
                this.selectRadio = "selectRadio";
                this.$store.state.compare.compareShowMode = "";
                if (this.$store.state.compare.screenList.length === 4) {
                    this.$store.state.compare.screenList.splice(-2, 2);
                }
                this.$store.state.showDeliveryDetail = false;
                this.layerOverlay = [];
                this.isLayer = false;
                this.sort = 3;
                // 重置订单中心的设置
                this.orderFunc = 0;
                this.optionTab = 0;
                this.$store.state.showDetail = false;
                this.$store.state.myLabFucChecked = 0;
                if (this.$store.state.isGallery===1){
                    this.changeGalleryTab();
                    this.changeOrderFunc();
                }
            },
            changeOrderFunc(){
                this.showLevel4 = false;
                this.orderStatus = "3";
                this.optionTabs[0].text = "全部";
                this.orderTypeSelected = "4";
                this.optionTabs[1].text = "全部";
                this.productTypeSelected = "ALL";
                this.optionTabs[2].text = "全部";
                this.startDate = null;
                this.endDate = null;
                this.menuStartDate = false;
                this.menuEndDate = false;
                this.optionTabs[3].text = "全部";
                this.searchID = "";
                this.initSet();
            },
            async changeGalleryTab(){
                // 切换“影像库”第2层的“浏览”“查找”“对比”时触发
                this.$store.state.showDeliveryDetail = false;
                if (this.$store.state.myLabFucChecked !== 2) {
                    this.utils.quitCompare(this.$store.state.compare);
                    this.galleryHeight = this.galleryBaseHeight = 40 + this.galleryTabs[this.$store.state.myLabFucChecked].childHeight;
                    this.showLevel4 = false;
                    this.$store.state.noneDelivery = false;
                    this.initDeliveryOptions();
                    this.layerOverlay = [];
                } else {
                    // 对比模式
                    this.$store.state.compare.compareShowMode = "screen";
                    this.selectRadio = "二分屏";
                    await this.initDeliveryCompare();
                }
            },
            switchMode(mode){
                // 修改tab的颜色
                switch (mode) {
                    case 'screen':
                        this.lineScreenColor = "#009999";    // 选中
                        this.lineRollerColor = "#9797974C";  // 未被选中
                        this.selectRadio = '二分屏'
                        break;
                    case 'roller':
                        this.lineScreenColor = "#9797974C";  // 未被选中
                        this.lineRollerColor = "#009999";    // 选中
                        this.selectRadio = '左右卷帘';
                        this.$store.state.compare.isVertical = false;
                        break;
                }
                if (this.$store.state.compare.compareShowMode === 'roller') {
                    this.utils.quitCompare(this.$store.state.compare);
                }
                this.$store.state.compare.compareShowMode = mode;
            },
            switchScreen(mode){
                this.utils.quitCompare(this.$store.state.compare);
                this.$store.state.compare.compareShowMode = "screen";
                switch (mode) {
                    case 2:
                        if (this.$store.state.compare.screenList.length === 4) {
                            this.$store.state.compare.screenList.splice(-2, 2);
                        }
                        break;
                    case 4:
                        if (this.$store.state.compare.screenList.length === 2) {
                            this.$store.state.compare.screenList.push(
                                {title: '2', isActive: false, isLeafletOff: true, curDataTitle: '', curLayerId: ''},
                                {title: '3', isActive: false, isLeafletOff: true, curDataTitle: '', curLayerId: ''}
                            )
                        }
                        break;
                }
                this.lineScreenColor = "#009999";    // 选中
                this.lineRollerColor = "#9797974C";  // 未被选中
            },
            switchRoll(mode){
                this.$store.state.compare.isVertical = mode;
                this.lineScreenColor = "#9797974C";  // 未被选中
                this.lineRollerColor = "#009999";    // 选中
                this.utils.quitCompare(this.$store.state.compare);
                this.$store.state.compare.compareShowMode = 'roller';
                this.eventVue.$emit("changeRoller");
            },
            initData(){
                this.isOrderLoading = true;
                // 获取客户的订单列表用pan的，客户经理的用management
                var myDate = new Date();
                console.log("打孟欣demandList接口"+myDate.toLocaleString())
                return this.axios.get("/demandService/pan/demandList", {
                    params: {
                        size: 10,               // 必填项
                        pageNum: this.orderPageNum,  // 必填项
                        demandState: this.orderStatus==='3'? null: this.orderStatus,
                        orderType: this.orderTypeSelected==='4'? null: this.orderTypeSelected,
                        productType: this.productTypeSelected==="ALL"? null: this.productTypeSelected,
                        startTime: this.startDate===""||!this.startDate? null: this.startDate+' 00:00:00',
                        endTime: this.endDate===""||!this.endDate? null: this.endDate+' 23:59:59',
                        keyWord: !this.searchID? null: this.searchID,
                        searchDetail: false,
                    }
                }).then(res => {
                  
                  for (let i = 0; i < res.data.data.records.length; i++) {
                    if (res.data.data.records[i].deliveryInfos && res.data.data.records[i].deliveryInfos.length > 0) {
                      for (let k = 0;k < res.data.data.records[i].deliveryInfos.length;k++){
                        const downloadStatus = res.data.data.records[i].deliveryInfos[k].isDownload;
                        if (downloadStatus === null || downloadStatus === undefined) {
                          res.data.data.records[i].deliveryInfos[k].isDownload = null;
                        } else if (downloadStatus === true) {
                          res.data.data.records[i].deliveryInfos[k].isDownload = '已下载';
                        } else if (downloadStatus === false) {
                          res.data.data.records[i].deliveryInfos[k].isDownload = '未下载';
                        } else {
                          res.data.data.records[i].deliveryInfos[k].isDownload = downloadStatus;
                        }
                      }
                    }
                  }
                    if (this.recordsList.length === 0) {
                        this.recordsList = res.data.data.records;
                    } else {
                        this.recordsList = this.recordsList.concat(res.data.data.records)
                    }
                    if (res.data.data.pages === "0"){
                        this.noneOrder = true;
                    } else {
                        this.orderPageMax = parseInt(res.data.data.pages);
                        this.orderPageNum += 1;
                        this.noneOrder = false;
                    }
                    this.orderTotal = res.data.data.total;           // “订单中心”列表的总订单数
                    this.loadingOrderNum = this.recordsList.length;  // “订单中心”列表的已加载订单数
                    this.isOrderLoading = false;
                    this.orderSearchClickable = true;
                })
            },
            saveStartDate(date){
                if (date){
                    this.optionTabs[3].text = "已设置";
                } else {
                    this.optionTabs[3].text = "全部";
                }
                this.$refs.menuStartDate.save(date);
                this.initSet();
            },
            saveEndDate(date){
                if (date){
                    this.optionTabs[3].text = "已设置";
                } else {
                    this.optionTabs[3].text = "全部";
                }
                this.$refs.menuEndDate.save(date);
                this.initSet();
            },
            savePhotoStartDate(date){
                this.$refs.menuPhotoStartDate.save(date)
            },
            savePhotoEndDate(date){
                this.$refs.menuPhotoEndDate.save(date)
            },
            showTabs(target, item, parentList){
                if (target === item && this.showLevel4) {
                    this.showLevel4 = false;
                    parentList.forEach(el => {
                        el.show = true;
                    })
                } else {
                    this.showLevel4 = true;
                    parentList.forEach(el => {
                        if (el.tab == item) {
                            el.show = true;
                        } else {
                            el.show = false;
                        }
                    })
                }
            },
            scrollCheck(event){
                if ((event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight) < 1){
                    this.searchKeyword(this.searchDelivery);
                }
            },
            searchKeyword(keyword){
                if (this.currentPage <= this.searchTotalPages) {
                    this.axios.get("/deliveryService/productInfo/searchProductSnapshotKeyword", {
                        params: {
                            keyword: keyword,
                            pageNum: this.currentPage,
                            size: 20
                        }
                    }).then(res => {
                        if (res.data.data.pages === 0) {
                            this.currentPage = 0;
                            this.searchTotalPages = 1;
                            this.noneSearchResult = true;
                            this.searchList = [];
                        } else if (this.currentPage===1){
                            this.noneSearchResult = false;
                            this.searchTotalPages = res.data.data.pages;
                            this.searchList = res.data.data.records;
                        } else {
                            this.noneSearchResult = false;
                            this.searchList.push(...res.data.data.records);
                        }
                        this.currentPage += 1;
                    })
                }
            },
            selectProduct(item){
                this.position = 0;
                this.menuKeyword = false;
                this.sidebarOpenList = [];
                this.searchRoot = this.deliveryDataList;
                this.searchProductCode = item.productCode;
                this.searchPath = item.folderPath.slice(1, item.folderPath.length);
            },
            async initDeliveryCompare(){

                this.isDeliveryLoading = true;
                return await this.axios.get("/deliveryService/productInfo/searchLayerProductList").then(res => {
                    this.isDeliveryLoading = true;
                    this.deliveryDataList = [];
                    for (let i = 0; i < res.data.data.length; i++) {
                        // 处理产品数据
                        res.data.data[i]["type"] = "product";
                        res.data.data[i]["id"] = res.data.data[i].productCode;
                        delete res.data.data[i].productCode;
                        res.data.data[i]["name"] = res.data.data[i].productName;
                        delete res.data.data[i].productName;
                        if (res.data.data[i].dataGeojson) {
                            res.data.data[i]["geojson"] = res.data.data[i].dataGeojson;
                            delete res.data.data[i].dataGeojson;
                        }
                    }
                    //alert("aaa")
                    if (res.data.data.length===0){
                        this.$store.state.noneDelivery = true;
                    }
                    this.deliveryDataList.push(...res.data.data);   // 因为要保持delivery指向Store下保存的，所以得一个个push
                    this.isDeliveryLoading = false;
                    return 'test'


                })
            },
            dragstart (item) {
                this.$store.state.compare.dropData = item;
            },
            loadChildren(item) {
                return this.initDeliveryData(item.children, item.id, item['parentPath']);
            },
            breadthFirstSearch(targetId, itemList){
                let children = [];
                for (let i = 0; i < itemList.length; i++) {
                    if (itemList[i].id === targetId) {
                        this.searchItemObject = itemList[i];
                    } else if (itemList[i].hasOwnProperty("children") && itemList[i].children.length !== 0) {
                        children.push({
                            "list": itemList[i].children
                        })
                    }
                }
                for (const child of children) {
                    this.breadthFirstSearch(targetId, child.list);
                }
            },
            initDeliveryData(delivery, id, parentPath){
                this.isDeliveryLoading = true;
                this.$set(this.section, 0, "");
                let judge = false;
                // 由于loadChildren只等一次异步，使用eventVue就会导致第二次，从而引起前端页面需要点击两次才能展开数据
                if (arguments.length === 0) {
                    this.deliveryDataList = [];
                    delivery = this.deliveryDataList;
                    id = null;
                    judge = true;
                }
                if(!parentPath) {
                    parentPath = [];
                }
                this.axios.get("/deliveryService/productInfo/getFolderList", {
                    params: {
                        productTypes: this.productTypes,
                        satelliteIds: this.satelliteIds,
                        timeSearchType: this.dateClass,
                        startTime: this.photoStartDate===null? this.photoStartDate: this.photoStartDate + " 00:00:00",
                        endTime: this.photoEndDate===null? this.photoEndDate: this.photoEndDate + " 23:59:59",
                        parentId: id,
                        sortByField: this.$store.state.sortByField,
                        sortDire: this.$store.state.sortDire
                    }
                }).then(res => {
                    this.isDeliveryLoading = true;
                    if (!res.data || !res.data.data) {
                        console.error("接口返回数据异常:", res);
                        return;
                    }
                    if (this.isLayer) {
                        this.deleteZipData(res.data.data);
                    }
                    this.utils.deepArrange(res.data.data, parentPath, id);
                    if (judge && res.data.data.children.length===0){
                        this.$store.state.noneDelivery = true;
                    }
                    if (arguments.length === 0) {
                        this.rootId = res.data.data.id;
                    }
                    delivery.push(...res.data.data.children);
                    if (this.$store.state.isDownloadUrl) {
                        this.getDownloadable(delivery);
                    }
                    if (id) {
                        this.sidebarOpenList.push(id);
                    }
                    if (this.searchPath.length > 0) {
                        if (this.searchPath.length > 1) {
                            this.searchRoot = delivery;
                            this.searchPath = this.searchPath.slice(1, this.searchPath.length);
                        } else {
                            this.$set(this.section, 0, this.searchProductCode);  // 选中数据
                            this.searchPath = [];
                        }
                    }
                    // 因为要保持delivery指向Store下保存的，所以得一个个push
                    this.$nextTick( () => {
                        this.isDeliveryLoading = false;
                        // this.layerOverlay = [];
                    });
                    // 这里双博给注销了，但是之前因为不返回有加载问题，等复现了再说
                    // return delivery;
                })
            },
            deleteZipData(data){
                for (let i = data.productInfos.length - 1; i >= 0; i--) {
                    if (data.productInfos[i].dataType === 1) {
                        data.productInfos.splice(i, 1);
                    }
                }
            },
            initDeliveryDataSync(delivery, id, parentPath){
                // 有时间删减一下无效代码
                this.isDeliveryLoading = true;
                this.$set(this.section, 0, "");
                let judge = false;
                // 由于loadChildren只等一次异步，使用eventVue就会导致第二次，从而引起前端页面需要点击两次才能展开数据
                if (arguments.length === 0) {
                    this.deliveryDataList = [];
                    delivery = this.deliveryDataList;
                    id = null;
                    judge = true;
                }
                let that=this;
                if(!parentPath) {
                    parentPath = [];
                }
                return new Promise(function (resolve) {
                    that.axios.get("/deliveryService/productInfo/getFolderList", {
                        params: {
                            productTypes: that.productTypes,
                            satelliteIds: that.satelliteIds,
                            timeSearchType: that.dateClass,
                            startTime: that.photoStartDate===null? that.photoStartDate: that.photoStartDate + " 00:00:00",
                            endTime: that.photoEndDate===null? that.photoEndDate: that.photoEndDate + " 23:59:59",
                            parentId: id,
                            sortByField: that.$store.state.sortByField,
                            sortDire: that.$store.state.sortDire
                        }
                    }).then(res => {
                        that.utils.deepArrange(res.data.data, parentPath, id);
                        if (judge && res.data.data.children.length===0){
                            that.$store.state.noneDelivery = true;
                        }
                        if (arguments.length === 0) {
                            that.rootId = res.data.data.id;
                        }
                        delivery.push(...res.data.data.children);
                        if (that.$store.state.isDownloadUrl) {
                            that.getDownloadable(delivery);
                        }
                        if (id) {
                            that.sidebarOpenList.push(id);
                        }
                        if (that.searchPath.length > 0) {
                            if (that.searchPath.length > 1) {
                                that.searchRoot = delivery;
                                that.searchPath = that.searchPath.slice(1, that.searchPath.length);
                            } else {
                                that.$set(that.section, 0, that.searchProductCode);  // 选中数据
                                that.searchPath = [];
                            }
                        }
                        // 因为要保持delivery指向Store下保存的，所以得一个个push
                        that.$nextTick( () => {
                            that.isDeliveryLoading = false;
                        })
                        resolve(delivery)
                    })
                })

            },
            arrangeFile(id){
                this.searchParent(id, this.rootId, this.deliveryDataList);
                this.$store.state.showPanel = true;
                this.$store.state.showCopyFile = false;
                this.$store.state.showDeliveryDetail = false;
                this.$store.state.sidebarTargetItem = this.selfItem;
                this.$store.state.sidebarTargetId = id;
            },
            searchParent(targetId, parentId, list){
                let children = [];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === targetId) {
                        this.selfItem = list[i];
                    } else if (list[i].hasOwnProperty("children") && list[i].children.length !== 0) {
                        children.push({
                            "selfItem": list[i].id,
                            "list": list[i].children
                        })
                    }
                }
                for (const child of children) {
                    this.searchParent(targetId, child.selfItem, child.list);
                }
            },
            async showDeliveryDetail(event, item){
                this.$store.state.showDeliveryDetail = false;
                this.$store.state.deliveryDetail = { "id": "" };
                this.$store.state.record = {};
                this.$store.state.hasOrderDetail = false;
                if (item.id !== this.$store.state.deliveryDetail.id) {
                    // 分别准备切片数据和zip数据
                    this.$store.state.deliveryDetail["dataType"] = item.dataType;
                    if (this.$store.state.deliveryDetail.dataType===2) {
                        await this.getProductServiceDetailById(item.internalDemandId);
                    } else if (this.$store.state.deliveryDetail.dataType===1) {
                        this.prepareZipDetail(item);
                    }
                    this.$store.state.detailTop = this.utils.calcHeight(event.clientY);
                    // 准备"订单详情"页面数据
                    this.$store.state.recordOrderType = item.orderType;
                    this.$store.state.deliveryDetail["packageOperation"]=item.packageOperation
                    //alert(this.$store.state.deliveryDetail.packageOperation)
                    this.$store.state.deliveryDetail["demandId"] = item.internalDemandId;
                    // 由于下面的事件里有根据这个判断是否展示订单panel的，所以需要在交付数据准备好后先设置
                    this.$store.state.showDeliveryDetail = true;
                    this.demandDetailId = item.internalDemandId;
                    if (this.$store.state.recordOrderType === 0) {
                        this.initArchivedDetail();
                    } else if (this.$store.state.recordOrderType === 1) {
                        this.initPointProgram();
                    } else if (this.$store.state.recordOrderType === 3) {
                        this.initLargeArea();
                    } else {
                        this.axios.get("/demandService/management/offlineDemandDetail", {
                            params: {
                                demandId: item.internalDemandId
                            }
                        }).then(res => {
                            this.$store.state.record.demandId = res.data.data.internalDemandId;
                            this.$store.state.record.requestName = res.data.data.requestName;
                            this.$store.state.record.createTime = res.data.data.demandCreateTime;
                            this.$store.state.hasOrderDetail = true;
                        })
                    }
                } else {
                    this.$store.state.showDeliveryDetail = true;
                }
            },
            prepareZipDetail(item){
                this.$store.state.deliveryDetail["name"] = item.name;  // zip页面展示“文件名称”
                if (item.productSize >= 1000000000) {                  // zip页面展示“文件大小”
                    this.$store.state.deliveryDetail["productSize"] = (item.productSize/1000000000).toFixed(2) + "GB";
                } else if (item.productSize >= 1000000) {
                    this.$store.state.deliveryDetail["productSize"] = (item.productSize/1000000).toFixed(2) + "MB";
                } else if (item.productSize >= 1000) {
                    this.$store.state.deliveryDetail["productSize"] = (item.productSize/1000).toFixed(2) + "KB";
                } else {
                    this.$store.state.deliveryDetail["productSize"] = item.productSize + "B";
                }
                if (item.deliveryTime) {            // zip页面展示“交付时间”
                    this.$store.state.deliveryDetail["deliveryTime"] = item.deliveryTime.slice(0, 19).replace("T", " ");
                } else {
                    this.$store.state.deliveryDetail["deliveryTime"] = "";
                }
                if (!item.productIds) {             // zip页面展示元数据列表
                    this.$store.state.deliveryDetail["showProductPanel"] = false;  // 控制是否展示zip下面的元数据列表
                } else {
                    this.$store.state.deliveryDetail["showProductPanel"] = true;
                    // 整理productIds
                    this.$store.state.deliveryDetail["productIds"] = [];
                    if (typeof item.productIds === 'string') {
                        item.productIds = item.productIds.slice(2, item.productIds.length-2).split(",")
                    }
                    for (let i = 0; i < item.productIds.length; i++) {
                        let id = item.productIds[i].slice(1, item.productIds[i].length-1)
                        id = id.replace("L1_MSS", "L1").replace("L1A_MSS", "L1A").replace("L1B_MSS", "L1B").replace("_PAN", "");
                        if (!this.$store.state.deliveryDetail["productIds"].includes(id)) {
                            this.$store.state.deliveryDetail["productIds"].push(id);
                        }
                    }
                    this.$store.state.deliveryDetail["productType"] = item.productType;
                    this.$store.state.deliveryDetail["productLevel"] = item.productLevel;
                }
                // 向阿潘获取元数据补充部分zip包的展示
                this.eventVue.$emit('showDeliveryDetail');
            },
            async downloadAll(item){
                // 先行加载子文件夹的数据
                await this._downloadFolderData(item);
                // 统计所有选中的项
                this.$store.state.fileNum = 0;
                this.$store.state.fileLink = [];
                this.num = item.productNum;
                this.getDownloadable(item.children);  // 不能直接用this.layerOverlay，因为中间会有空文件夹的ID
                if (this.$store.state.fileNum === 0){
                    this.snackbarColor="error";
                    this.snackbarInfo = "请勾选文件后再进行下载";
                    this.snackbar = true;
                } else {
                    this.$store.state.isFolder = true;
                    this.$store.state.fileName = item.name;
                    this.$store.state.showCopyFile = true;
                }
            },
            async _downloadFolderData(item){
                if (item.productNum && item.productNum !== 0){
                    for (const child of item.children) {
                        if (child.type === 'folder' && child.productNum !== 0){
                            if (child.children.length === 0) {
                                await this.initDeliveryDataSync(child.children, child.id, child.parentPath);
                            }
                            await this._downloadFolderData(child)
                        } else if (child.type === 'product') {
                            this.getDownloadable(child)
                        }
                    }
                }
            },
            getDownloadable(children){
                for (let i = 0; i < children.length; i++) {
                    if (children[i].dataType === 1) {
                        this.num -= 1;
                        if (this.layerOverlay.includes(children[i].id)) {
                            this.$store.state.fileNum += 1;
                            this.$store.state.fileLink.push(children[i].deliveryUrl);
                        }
                        if (this.num === 0){
                            this.$store.state.isDownloadUrl = false;
                        }
                    } else if (children[i].type === "folder" && children[i].productNum !== 0) {
                        if (children[i].children.length !== 0){
                            this.getDownloadable(children[i].children);
                        }
                    }
                }
            },
            download(item){
                this.$store.state.fileLink = [item.deliveryUrl];
                this.$store.state.isFolder = false;
                this.$store.state.fileName = item.name;
                this.$store.state.fileNum = 1;
                this.$store.state.fileSize = item.productSize;
                this.$store.state.showCopyFile = true;
            },
            copySuccess() {
                this.snackbarColor="success"
                this.snackbarInfo = "已复制到剪切板"
                this.snackbar = true;
            },
            copyError() {
                this.snackbarColor="error";
                this.snackbarInfo = "复制失败";
                this.snackbar = true;
            },
            getLayerData(item){
                // 有两种情况会进入：未勾选条件下点击，未勾选条件下勾选一个切片
                if (!item.dataGeojson) {
                    return this.axios.get("/highmanage/seniorProductMgr/getProductServiceDetailById", {
                        params: {
                            productId: item.internalDemandId
                        }
                    }).then(res => {
                        item.dataGeojson = JSON.parse(res.data.data.geo);
                        let symbol = res.data.data.serviceUrl.indexOf('?') === -1? "?": "&&";
                        item.serviceUrl = res.data.data.serviceUrl + symbol + "token=" + this.$store.state.user.token;
                        // 添加图层
                        if (!Object.keys(this.layerIdDict).includes(item.id)) {
                            this.layerIdDict[item.id] = this.utils.addCesiumLayer(item.serviceUrl, item.dataGeojson);
                        }
                        // 勾选上复选框
                        if (!this.layerOverlay.includes(item.id)) {
                            this.$set(this.layerOverlay, this.layerOverlay.length, item.id);
                        }
                    })
                }
            },
            zoomGeo(geo){
                let that = this;
                let center = turf.envelope(geo).geometry.coordinates[0];  // 算一个中心点
                window.viewer.camera.flyTo({
                    destination: this.Cesium.Rectangle.fromDegrees(center[0][0], center[0][1], center[2][0], center[2][1]),
                    complete: function(){
                        that.$store.state.level = that.utils.getCameraLevel(
                            Math.ceil(window.viewer.camera.positionCartographic.height)
                        );
                    }
                })
            },
            compareArray(newVal, oldVal) {
                let newLayerIdList = [];
                if (newVal.length >= oldVal.length) {
                    for (const newValItem of newVal) {
                        if (!oldVal.includes(newValItem)) {
                            newLayerIdList.push(newValItem);
                        }
                    }
                } else if (newVal.length < oldVal.length) {
                    for (const oldValItem of oldVal) {
                        if (!newVal.includes(oldValItem)) {
                            newLayerIdList.push(oldValItem);
                        }
                    }
                }
                return newLayerIdList;
            },
            showOrderDetail(event, item, func){
                //(item)
                this.$store.state.demandTabFunc = func;
                this.$store.state.showDetail = false;
                this.$store.state.recordOrderType = item.orderType;
                this.$store.state.record = {};
                this.$store.state.hasOrderDetail = false;
                // 获取订单Panel的“切片列表”
                this.$store.state.deliveryDetail = { "id": "" };
                this.$store.state.isTile = item.isTile;
                if (this.$store.state.isTile) {
                    this.getProductServiceDetailById(item.demandId);
                }
                // 获取订单panel的“数据列表”
                this.prepareOrderPanel2(item);
                this.$store.state.showDetail = true;  // 控制订单panel页面显示的
                // 获取订单Panel的“订单详情”
                this.$store.state.detailTop = this.utils.calcHeight(event.clientY);
                this.demandDetailId = item.demandId
                if (this.$store.state.recordOrderType === 0) {
                    this.initArchivedDetail()
                } else if (this.$store.state.recordOrderType === 1) {
                    this.initPointProgram();
                } else if (this.$store.state.recordOrderType === 3) {
                    this.initLargeArea();
                } else {
                    this.$store.state.record.demandId = item.demandId;
                    this.$store.state.record.requestName = item.requestName;
                    this.$store.state.record.createTime = item.createTime;
                    this.$store.state.hasOrderDetail = true;
                }
            },
            prepareOrderPanel2(item){
                if (item.deliveryInfos.length !== 0){
                    for (const delivery of item.deliveryInfos) {
                        delivery["metaFileSize"] = delivery.fileSize;
                        // 处理“数据列表”的表格中“文件大小”的展示数据
                        if (delivery.fileSize >= 1073741824) {
                          delivery.fileSize = (delivery.fileSize/1073741824).toFixed(2) + "GB";
                        } else if (delivery.fileSize >= 1048576) {
                          delivery.fileSize = (delivery.fileSize/1048576).toFixed(2) + "MB";
                        } else if (delivery.fileSize >= 1024) {
                          delivery.fileSize = (delivery.fileSize/1024).toFixed(2) + "KB";
                        } else {
                          delivery.fileSize = delivery.fileSize + "B";
                        }
                        delivery.finishTime = delivery.finishTime.slice(0, 19);
                    }
                }
                this.$store.state.deliveryDetail["deliveryInfos"] = item.deliveryInfos;

                // 直接对 Vuex state 进行赋值，但是加入安全检查
                if (item.largeAreaDeliveryInfos !== undefined) {
                  this.$store.state.deliveryDetail["largeAreaDeliveryInfos"] = JSON.parse(JSON.stringify(item.largeAreaDeliveryInfos));
                } else {
                  this.$store.state.deliveryDetail["largeAreaDeliveryInfos"] = {};
                }

                //alert(this.$store.state.deliveryDetail.deliveryInfos[0].packageOperation)

                this.$store.state.orderId = item.demandId;
                this.$store.state.deliveryDetail["dataDeleted"] = item.dataDeleted;
                this.$store.state.deliveryDetail["requestName"] = item.requestName;  // 图像名称
            },
            getProductServiceDetailById(demandId){
                // 准备切片
                return this.axios.get("/demandService/management/getTileCacheProductionInfo", {
                    params: {
                        internalDemandId: demandId
                    }
                }).then(res => {
                    this.$store.state.deliveryDetail["tileState"] = res.data.data.state;        // 切片状态
                    //alert(this.$store.state.deliveryDetail["tileState"])
                    this.$store.state.deliveryDetail["productName"] = res.data.data.layerName;  // 图像名称
                    if (this.$store.state.deliveryDetail.tileState === 2) {
                         return this.axios.get("/highmanage/seniorProductMgr/getProductServiceDetailById", {
                            params: {
                                productId: demandId
                            }
                        }).then(res => {
                            this.$store.state.deliveryDetail["productTime"] = "----年--月--日";            // 图层时相
                            // 切片层级
                            this.$store.state.deliveryDetail["level"] = res.data.data.startLevel + "-" + res.data.data.endLevel;
                            this.$store.state.deliveryDetail["format"] = res.data.data.format;            // 数据格式
                            this.$store.state.deliveryDetail["area"] = res.data.data.area;                // 覆盖面积
                            this.$store.state.deliveryDetail["gmtCreated"] = res.data.data.gmtCreated.replace("T", " ").slice(0, 19);    // 发布时间
                            // 数据大小
                            if (res.data.data.zipSize >= 1000000000) {
                                this.$store.state.deliveryDetail["zipSize"] = (res.data.data.zipSize/1000000000).toFixed(2) + "GB";
                            } else if (res.data.data.zipSize >= 1000000) {
                                this.$store.state.deliveryDetail["zipSize"] = (res.data.data.zipSize/1000000).toFixed(2) + "MB";
                            } else if (res.data.data.zipSize >= 1000) {
                                this.$store.state.deliveryDetail["zipSize"] = (res.data.data.zipSize/1000).toFixed(2) + "KB";
                            } else {
                                this.$store.state.deliveryDetail["zipSize"] = res.data.data.zipSize + "B";
                            }
                            // 以下是页面"代码"中需要展示
                            this.$store.state.deliveryDetail["productId"] = res.data.data.productId;
                            this.$store.state.deliveryDetail["properties"] = res.data.data.properties;
                            this.$store.state.deliveryDetail["styleStr"] = res.data.data.styleStr;
                            this.$store.state.deliveryDetail["geo"] = res.data.data.geo;
                            this.$store.state.deliveryDetail["serviceUrl"] = res.data.data.serviceUrl.indexOf('?') === -1?
                                res.data.data.serviceUrl + "?token=" + this.$store.state.user.token: res.data.data.serviceUrl + "&&token=" + this.$store.state.user.token;
                            return this.$store.state.deliveryDetail["productName"];
                        })
                    } else {
                        return "false";
                    }
                })
            },
            showGallery(id){
                this.galleryHeight = this.galleryBaseHeight = 40 + this.galleryTabs[this.$store.state.myLabFucChecked].childHeight;
                this.$store.state.noneDelivery = false;
                this.layerOverlay = [];
                this.$store.state.isGallery = 0;        // 控制“影像库”与“订单中心”的切换，changeSidebar()是这一层的切换控制func
                this.$store.state.myLabFucChecked = 1;  // 控制“影像库”的“筛选”与“查找”的切换，changeGalleryTab()是这一层的切换控制func
                this.$store.state.showDetail = false;
                if (this.searchDelivery === id) {
                    this.menuKeyword = true;
                } else {
                    this.searchDelivery = id;
                }
            },
            scrollPanel(event){
                if ((event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight) < 1){
                    if (this.orderPageMax !== 1 && this.orderPageNum <= this.orderPageMax) {
                        this.initData();
                    }
                }
            },
            getDemandState(state){
                switch (state) {
                    case 7:
                        return "已关闭";
                    case 8:
                        return "已取消";
                    case 9:
                        return "已完成";
                    default:
                        return "进行中";
                }
            },
            getDemandStateColor(state){
                switch (state) {
                    case 7:
                        return "#101010";
                    case 8:
                        return "#101010";
                    case 9:
                        return "#329999";
                    default:
                        return "#CF736E";
                }
            },
            confirmDeliveryTime(){
                // “确认”后使用最新的时间
                this.photoStartDate = this.tempPhotoStartDate;
                this.photoEndDate = this.tempPhotoEndDate;
                // 修改界面“时间”tab下的文字
                if (this.photoStartDate){
                    this.browserTabs[2].text = "已设置";
                } else {
                    this.browserTabs[2].text = "全部";
                }
                this.initDeliveryData();
            },
            resetDeliveryTime(){
                this.dateClass = "imagingTime";
                this.tempPhotoStartDate = null;
                this.photoStartDate = null;
                this.tempPhotoEndDate = null;
                this.photoEndDate = null;
                this.browserTabs[2].text = "全部";
                this.initDeliveryData();
            },
            confirmDataType(){
                // “确认”后使用最新的数据类型
                this.dataTypeSelect = this.tempDataTypeSelect;
                if (this.dataTypeSelect.length === 8) {
                    this.browserTabs[0].text = "全部";
                    this.productTypes = null;
                } else if (this.dataTypeSelect.length === 0) {
                    this.browserTabs[0].text = "未选择";
                    this.productTypes = "";
                } else {
                    this.browserTabs[0].text = "部分选择";
                    this.productTypes = this.dataTypeSelect.join(",");
                }
                this.initDeliveryData();
            },
            resetDataType(){
                this.dataTypeSelect = ["IMAGE", "MULTISPECTRAL", "NIGHT", "VIDEO", "LPB", "STERO", "OTHER", "OFFLINE"];
                this.tempDataTypeSelect = ["IMAGE", "MULTISPECTRAL", "NIGHT", "VIDEO", "LPB", "STERO", "OTHER", "OFFLINE"];
                this.browserTabs[0].text = "全部";
                this.productTypes = null;
                this.initDeliveryData();
            },
            confirmSatellite(){
                // “确认”后使用最新的数据类型
                this.satelliteSelect = this.tempSatelliteSelect.slice(0);
                if (this.satelliteSelect.length === 22) {
                    this.browserTabs[1].text = "全部";
                    this.satelliteIds = null;
                } else if (this.satelliteSelect.length === 0) {
                    this.browserTabs[1].text = "未选择";
                    this.satelliteIds = "";
                } else {
                    this.browserTabs[1].text = "部分选择";
                    this.satelliteIds = this.satelliteSelect.join(",");
                }
                this.initDeliveryData();
            },
            resetSatellite(){
                this.satelliteSelect = [
                    "JL101A", "JL103B", "JL104B", "JL105B", "JL106B", "JL107B", "JL108B", "JL101C", "JL102C", "JL101D", "JL101E", "JL102E",
                    "JL101K", "JL1GF03B01", "JL1GF03B02", "JL1GF03B03", "JL1GF03B04", "JL1GF03B05", "JL1GF03B06", "JL1GF03C01", "JL1GF03C02",
                    "JL1GF03C03"
                ];
                this.tempSatelliteSelect = [
                    "JL101A", "JL103B", "JL104B", "JL105B", "JL106B", "JL107B", "JL108B", "JL101C", "JL102C", "JL101D", "JL101E", "JL102E",
                    "JL101K", "JL1GF03B01", "JL1GF03B02", "JL1GF03B03", "JL1GF03B04", "JL1GF03B05", "JL1GF03B06", "JL1GF03C01", "JL1GF03C02",
                    "JL1GF03C03"
                ];
                this.browserTabs[1].text = "全部";
                this.satelliteIds = null;
                this.initDeliveryData();
            },
            initDeliveryOptions(){
                // 相当于集体重置
                // 针对起始时间、终止时间
                this.dateClass = "imagingTime";
                this.tempPhotoStartDate = null;
                this.photoStartDate = null;
                this.tempPhotoEndDate = null;
                this.photoEndDate = null;
                this.browserTabs[2].text = "全部";
                // 针对数据类型
                this.dataTypeSelect = ["IMAGE", "MULTISPECTRAL", "NIGHT", "VIDEO", "LPB", "STERO", "OTHER", "OFFLINE"];
                this.tempDataTypeSelect = ["IMAGE", "MULTISPECTRAL", "NIGHT", "VIDEO", "LPB", "STERO", "OTHER", "OFFLINE"];
                this.browserTabs[0].text = "全部";
                this.productTypes = null;
                // 针对成像卫星
                this.satelliteSelect = [
                    "JL101A", "JL103B", "JL104B", "JL105B", "JL106B", "JL107B", "JL108B", "JL101C", "JL102C", "JL101D", "JL101E", "JL102E",
                    "JL101K", "JL1GF03B01", "JL1GF03B02", "JL1GF03B03", "JL1GF03B04", "JL1GF03B05", "JL1GF03B06", "JL1GF03C01", "JL1GF03C02",
                    "JL1GF03C03"
                ];
                this.tempSatelliteSelect = [
                    "JL101A", "JL103B", "JL104B", "JL105B", "JL106B", "JL107B", "JL108B", "JL101C", "JL102C", "JL101D", "JL101E", "JL102E",
                    "JL101K", "JL1GF03B01", "JL1GF03B02", "JL1GF03B03", "JL1GF03B04", "JL1GF03B05", "JL1GF03B06", "JL1GF03C01", "JL1GF03C02",
                    "JL1GF03C03"
                ];
                this.browserTabs[1].text = "全部";
                this.satelliteIds = null;
                this.initDeliveryData();
            },
            // 以下复制来自Pan
            toggleAll (val) {
                if(this.countIncluded(val) < this.satelliteGroup[val].length){
                    // 当该展开框中数量少于总长度时，做全选
                    this.satelliteGroup[val].forEach( item => {
                        if( !this.tempSatelliteSelect.includes(item.value) ){
                            this.tempSatelliteSelect.push(item.value)
                        }
                    })
                } else {
                    // 当该展开框中数量 === 总长度时，做全不选
                    for (const item of this.satelliteGroup[val]) {
                        let itemIndex = this.tempSatelliteSelect.indexOf(item.value)
                        if(itemIndex!==-1){
                            this.tempSatelliteSelect.splice(itemIndex , 1)
                        }
                    }
                }
            },
            countIncluded(val){
                // 判断是否用
                // 计算已勾选的卫星数量
                let count = 0
                for (const item of this.satelliteGroup[val]) {
                    if(this.tempSatelliteSelect.includes(item.value)) {
                        count = count + 1;
                    }
                }
                return count
            },
            changeOrderStatus(){
                // 切换订单状态标识
                switch (this.orderStatus) {
                    case "0":
                        this.optionTabs[0].text = "进行中";
                        break;
                    case "1":
                        this.optionTabs[0].text = "已完成";
                        break;
                    case "2":
                        this.optionTabs[0].text = "已关闭";
                        break;
                    case "3":
                        this.optionTabs[0].text = "全部";
                        break;
                }
                this.initSet();
            },
            changeOrderTypeSelected(){
                switch (this.orderTypeSelected) {
                    case "0":
                        this.optionTabs[1].text = "标准景";
                        break;
                    case "1":
                        this.optionTabs[1].text = "点编程";
                        break;
                    case "2":
                        this.optionTabs[1].text = "其他";
                        break;
                    case "3":
                        this.optionTabs[1].text = "大区域编程";
                        break;
                    case "4":
                        this.optionTabs[1].text = "全部";
                        break;
                }
                this.initSet();
            },
            changeProductTypeSelected(){
                switch (this.productTypeSelected) {
                    case "ALL":
                        this.optionTabs[2].text = "全部";
                        break;
                    case "IMAGE":
                        this.optionTabs[2].text = "普通光学";
                        break;
                    case "NIGHT":
                        this.optionTabs[2].text = "夜光";
                        break;
                    case "VIDEO":
                        this.optionTabs[2].text = "视频";
                        break;
                    case "MULTISPECTRAL":
                        this.optionTabs[2].text = "多光谱";
                        break;
                    case "LPB":
                        this.optionTabs[2].text = "推扫";
                        break;
                    case "STERO":
                        this.optionTabs[2].text = "立体";
                        break;
                }
                this.initSet();
            },
            changeIsLayer(){
                this.isLayer = !this.isLayer;
                this.$store.state.showDeliveryDetail = false;
                this.initDeliveryData();
            },
            changeSort(){
                this.$store.state.showDeliveryDetail = false;
            },
            initArchivedDetail(){
                this.axios.get('/demandService/management/archivedDemandDetail', {
                    params: {
                        demandId: this.demandDetailId
                    }
                }).then(res => {
                    if (this.requestTime.toLocaleString() === res.config.requestTime.toLocaleString()) {
                        this.$store.state.record = res.data.data;
                        this.$store.state.record['demandId'] = this.demandDetailId;
                        this.$store.state.record['createTime'] = res.data.data.demandCreateTime;
                        this.$store.state.record.projection = this.projectionOptions[this.$store.state.record.projection];
                        this.$store.state.record.productType = this.productTypeOptionsDict[this.$store.state.record.productType];
                        //this.$store.state.record.productDetails.forEach(item => {
                        //    item.satelliteId = this.satelliteNewList[item.satelliteId];
                        //})
                        this.$store.state.hasOrderDetail = true;
                    }
                })
            },
            initPointProgram(){
                this.axios.get("/demandService/management/programingDemandDetail", {
                    params: {
                        demandId: this.demandDetailId
                    }
                }).then(res => {
                    if (this.requestTime.toLocaleString() === res.config.requestTime.toLocaleString()) {
                        this.$store.state.record = res.data.data;
                        this.$store.state.record["panelMode"] = "point";
                        this.$store.state.record["demandId"] = this.demandDetailId;
                        // 修改成像模式
                        this.$store.state.record.imagingMode = this.imagingModeOptions[this.$store.state.record.imagingMode];
                        // 修改投影方式
                        this.$store.state.record.projection = this.projectionOptions[this.$store.state.record.projection];
                        // 修改时间
                        this.$store.state.record.startTime = this.$store.state.record.startTime.substring(0, 10);
                        this.$store.state.record.endTime = this.$store.state.record.endTime.substring(0, 10);
                        let imagingWkt;
                        if(this.$store.state.record.imagingWkt.indexOf("GEOMETRYCOLLECTION")!=-1) {
                            imagingWkt = this.$store.state.record.imagingWkt.split("GEOMETRYCOLLECTION(")[1].split("))),")[0]+")))"
                        } else {
                            imagingWkt = this.$store.state.record.imagingWkt
                        }
                        this.$store.state.record.geo = WKT.parse(imagingWkt);
                        this.$store.state.hasOrderDetail = true;
                    }
                })
            },
            initLargeArea() {
                this.axios.get("/demandService/management/largeAreaDemandDetail", {
                    params: {
                        demandId: this.demandDetailId
                    }
                }).then(res => {
                    if (this.requestTime.toLocaleString() === res.config.requestTime.toLocaleString()) {
                        this.$store.state.record["panelMode"] = "area";
                        this.$store.state.record = res.data.data;
                        this.$store.state.record["demandId"] = this.demandDetailId;
                        this.$store.state.record.imagingMode = this.imagingModeOptions[this.$store.state.record.imagingMode];
                        this.$store.state.record.startTime = this.$store.state.record.startTime.substring(0, 10);
                        this.$store.state.record.endTime = this.$store.state.record.endTime.substring(0, 10);
                        this.$store.state.record.projection = this.projectionOptions[this.$store.state.record.projection];
                        this.$store.state.record["selectArea"] = (parseInt(this.$store.state.record.completionStatusInfo.selectArea) / 1000000).toFixed(2);
                        if(this.$store.state.record.imagingWkt.indexOf("GEOMETRYCOLLECTION")!=-1) {
                            // imagingWkt = this.$store.state.record.imagingWkt.split("GEOMETRYCOLLECTION(")[1].split(")),")[0]+")))"
                            this.$store.state.record.geo = null;
                        } else {
                            this.$store.state.record.geo = WKT.parse(this.$store.state.record.imagingWkt);
                        }
                        this.$store.state.hasOrderDetail = true;
                    }
                })
            },
        },
    };
</script>
<style>
    .select-first-level{
        background-color: #2F4249;
    }
    .side-bar {
        width: 430px;
        height: 100%;
        float: left;
        background-color: #212d31;
        overflow: hidden;
    }
    .div-out{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width:50%;
        margin: 0.5rem 0.5rem;
    }
    .div-line{
        width: 3px;
        height: 2rem;
        margin-left: 0;
    }
    .div-img-out{
        display: flex;
        flex-direction: column;
        margin-left: 0.5rem;
        cursor: pointer;
        font-size: 14px;
    }
    .compare-label{
        color: #ffffff;
        cursor: pointer
    }
    .selectCompare-radioLine{
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-left: 1rem;
        height: 3rem;
    }
    .selectCompare-roller-radioItem{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .selectCompare-radioLabel{
        width: 100%;
        height: 100%;
        display: block;
        font-size: 12px;
        color: #ffffff;
        cursor: pointer;
    }
    .display_flex{
        display: flex;
    }
    .order-title-name{
        display: flex;
        width: 100%;
        height: 25px;
        margin-left: 0px;
        background-color: rgba(47, 66, 73, 100);
        justify-content: space-between;
    }
    .order-title-name p{
        color: #F3EFEF;
        font-size: 13px;
        padding: 3px 10px;
    }
    .green-line {
        width: 4px;
        height: 25px;
        background-color: rgba(50, 153, 153, 100);
    }
    .time-style{
        display: flex;
        justify-content: space-around;
    }
    .gallery-item{
        display: flex;
        flex-wrap: wrap;
        margin: 4px 10px;
    }
    .gallery-item .mdi:before, .v-radio .mdi:before {
        font-size: 18px;
    }
    .gallery-item .v-icon.v-icon::after, .v-radio .v-icon.v-icon::after {
        transform: scale(1);
    }
    .gallery-item .v-expansion-panel-header {
        padding: 0px 4px;
    }
    .gallery-item .v-expansion-panel-content__wrap {
        padding: 0px;
    }
    .gallery-item .v-input .v-input__control {
        margin: 0px 4px;
    }
    .side-bar .v-input__control .v-messages, #filter v-window__container {
        display: none;
    }
    .v-window-item .v-input--selection-controls, .time-style .v-text-field {
        margin-top: 4px;
        padding-top: 0px;
    }
    .delivery-style {
        height: 100%;
        width: 100%;
    }
    .delivery-style .__view {
        max-width: 100%;
    }
    .delivery-style .v-list-item::after{
        display: none;
    }
    .homeLeftBarDataLabListTitle{
        width: 100%;
        height: 1.5rem;
        background: #2F4249;
        border-left: 4px solid #339999;
    }
    .title-name{
        margin: 0.1rem 0rem 0rem 0.5rem;
        float:left;
        line-height: 1.3rem;
        font-size: 14px;
        color: #ffffff;
    }
    .title-button{
        width: 35px;
        height: 0.8rem;
        margin: 0.3rem 10px 0 0;
        font-size: 12px;
        float: right;
    }
    #dataList {
        width: 100%;
    }
    #dataList .v-treeview-node__checkbox {
        width: 21px;
    }
    #dataList .mdi:before, .mdi-set{
        font-size: 20px;
    }
    .list-item-name {
        font-size: 14px;
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    .list-item-name-label {
        width: 90%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 30px;
    }
    .sort-img {
        width: 15px;
        height: 15px;
        margin: 4px 8px 0px 10px;
    }
    .content{
        width: 100%;
        line-height: 26px;
        padding: 10px 15px 10px 10px;
        color: #D1D5D6;
        font-size: 13px;
    }
    .order-list {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        background-color: #212D31;
    }
    .order-list::-webkit-scrollbar {
        width: 6px;
        height: 8px;
    }
    .order-list::-webkit-scrollbar-thumb {
        background: #374C53;
        border-radius: 10px;
    }
    .order-list::-webkit-scrollbar-track {
        background: #1E1E1E;
    }
    .order-list .v-list-item{
        padding: 0px;
    }
    .list-item-style {
        display: flex;
        flex-direction: column;
        padding: 0px 8px;
    }
    .list-item-style ::before,::after{
        display: none;
    }
    /*修改对Vuetify的控制*/
    #changeData .v-input__control {
        margin: 0px;
    }
    #changeData .v-input--selection-controls__input {
        margin: 0px 4px;
        width: 36px;
    }
    #changeData .v-input--selection-controls__ripple {
        height: 14px;
        width: 36px;
        top: calc(50% - 8px);
    }
    #changeData .v-input .v-input--selection-controls__input {
        margin: 3px 0px;
        height: 10px;
    }
    #changeData .v-input--switch.v-input--dense .v-input--switch__thumb {
        width: 16px;
        height: 16px;
    }
</style>
